// import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
// react
import React from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { Box, Button, Typography } from '@mui/material';

interface ToolApprovalPromptProps {
  approval: {
    id: string;
  };
  toolInput?: unknown;
  onApprove: (id: string) => void;
  onDeny: (id: string) => void;
}

export const ToolApprovalPrompt: React.FC<ToolApprovalPromptProps> = ({
  approval,
  toolInput,
  onApprove,
  onDeny,
}) => {
  const { t } = useTranslation('ai-assistant');
  return (
    <Box>
      {toolInput && (
        <Box sx={{ mb: 1.5 }}>
          <Typography
            variant="caption"
            fontWeight={600}
            sx={{ color: 'text.secondary', mb: 0.5, display: 'block' }}
          >
            {t('tools.parametersToUse')}:
          </Typography>
          <Box
            component="pre"
            sx={{
              fontSize: '0.75rem',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              m: 0,
              p: 1.5,
              borderRadius: 1,
              bgcolor: (theme) =>
                theme.palette.mode === 'light' ? 'grey.100' : 'grey.800',
              fontFamily: 'monospace',
              border: (theme) =>
                `1px solid ${
                  theme.palette.mode === 'light'
                    ? theme.palette.grey[300]
                    : theme.palette.grey[700]
                }`,
            }}
          >
            {JSON.stringify(toolInput, null, 2)}
          </Box>
        </Box>
      )}

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          onClick={() => onApprove(approval.id)}
          variant="text"
          disableElevation
          //   color="success"
          size="small"
          //   startIcon={<CheckRoundedIcon />}
          fullWidth
          sx={{
            textTransform: 'none',
            ':hover': {
              bgcolor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.success.light
                  : theme.palette.success.dark,
            },
            // fontWeight: 600,
          }}
        >
          {t('actions.confirm')}
        </Button>
        <Button
          onClick={() => onDeny(approval.id)}
          variant="text"
          //   color="error"
          size="small"
          //   startIcon={<CloseRoundedIcon />}
          fullWidth
          sx={{
            textTransform: 'none',
            ':hover': {
              bgcolor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.error.light
                  : theme.palette.error.dark,
            },

            // fontWeight: 600,
          }}
        >
          {t('actions.reject')}
        </Button>
      </Box>
    </Box>
  );
};
